import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { updatedIsSelected } from 'services/apiComparable'

const useIsSelectedComp = () => {
    const queryClient =useQueryClient();
  const {isPending: isSelecting, isSuccess: isSelected, mutate: updateIsSelected,mutateAsync} = useMutation({
    mutationFn: updatedIsSelected,
    onSuccess:(data)=>{
        queryClient.setQueryData(['updatedIsSelectedComp'],data)
        queryClient.invalidateQueries({queryKey:['compList']})
    },
    onError:(error)=>{
        console.log("Error occurred when creating Org",error)
                if (error?.data && typeof error.data === 'object') {
                // Display all backend validation errors
                for (const key in error.data) {
                    const msg = error.data[key];
                    toast.error(Array.isArray(msg) ? msg[0] : msg);
                }
            } else {
                toast.error(error.message || "Something went wrong.");
            }
    }
  })

  return{isSelecting, isSelected, updateIsSelected,mutateAsync}
}

export default useIsSelectedComp